import { action, reatomBoolean } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'
import { isBrowserLocalAtom } from '@root/shared/core'

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/browserLocalWarningSeen`

export const browserLocalWarningSeenAtom = reatomBoolean(
  false,
  'browserLocalWarningSeenAtom',
).pipe(withLocalStorage(STORAGE_KEY))

export const browserLocalWarningDialogOpenAtom = reatomBoolean(
  false,
  'browserLocalWarningDialogOpenAtom',
)

export const initializeBrowserLocalWarningDialogAction = action((ctx) => {
  const isBrowserLocal = ctx.get(isBrowserLocalAtom)
  if (!isBrowserLocal) {
    return
  }
  const browserLocalWarningSeen = ctx.get(browserLocalWarningSeenAtom)
  if (browserLocalWarningSeen) {
    return
  }
  browserLocalWarningDialogOpenAtom(ctx, true)
}, 'initializeBrowserLocalWarningDialogAction')
